import React from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import { Button, Tooltip, Typography } from '@material-ui/core';

import WarningIcon from '@material-ui/icons/Warning';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import HomeIcon from '@material-ui/icons/Home';
import BorderClearIcon from '@material-ui/icons/BorderClear';

import InfoCardList from '../common/InfoCardList';
import AreaInfoCard from '../common/AreaInfoCard';
import InfoCard from '../common/InfoCard';
import PotentialUnitsInfoCard from '../common/PotentialUnitsInfoCard';
import BuildableAreaInfoCard from '../common/BuildableAreaInfoCard';

const useStyles = makeStyles((theme) => style(theme));

const propTypes = {

};

const defaultProps = {

};

function LandAssemblyAggregates () {
    const classes = useStyles();
    const isLoading = useSelector(state => state.landAssembly.isFetchingStats);
    const totalArea = useSelector(state => {
        return (!state.landAssembly.isFetchingStats && state.landAssembly.stats !== null) ?
            state.landAssembly.stats.totalArea :
            0;
    });
    const totalBuildableArea = useSelector(state => {
        return (!state.landAssembly.isFetchingStats && state.landAssembly.stats !== null) ?
            100 - (state.landAssembly.stats.results.find(e => e.id === null && e.type === 'area').value || 0) :
            0;
    });

    return ( <InfoCardList>
        <AreaInfoCard skeleton={isLoading} value={totalArea} />
        <BuildableAreaInfoCard isLoading={isLoading} buildableArea={totalBuildableArea} />
        <PotentialUnitsInfoCard
            isLoading={isLoading}
            area={totalArea}
            buildableArea={totalBuildableArea}
        />
    </InfoCardList>);
}

LandAssemblyAggregates.propTypes = propTypes;
LandAssemblyAggregates.defaultProps = defaultProps;

const style = theme => ({

});

export default LandAssemblyAggregates;